import { render, staticRenderFns } from "./projectDetail.vue?vue&type=template&id=54aae4d8&scoped=true"
import script from "./projectDetail.vue?vue&type=script&lang=js"
export * from "./projectDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aae4d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54aae4d8')) {
      api.createRecord('54aae4d8', component.options)
    } else {
      api.reload('54aae4d8', component.options)
    }
    module.hot.accept("./projectDetail.vue?vue&type=template&id=54aae4d8&scoped=true", function () {
      api.rerender('54aae4d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectSettlement/components/dialogs/projectDetail.vue"
export default component.exports